import { Acties } from "@/features/acties";
import { RoleGate, UserRole } from "@/features/auth";
import { Herinneringen } from "@/features/herinneringen";
import { Logboek } from "@/features/logboek";
import { Suggesties } from "@/features/suggesties";
import { SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarSeparator } from "@/shared/components";
import { Timeline, TimelineLine } from "@/shared/components/ui/timeline";
import { Ref } from "react";
import { Filter } from "../types";

interface TijdlijnProps {
    dossierNummer: string;
    activeFilters: Filter[];
    readOnly?: boolean;
    ref: Ref<HTMLDivElement>;
}

export function Tijdlijn({ dossierNummer, activeFilters, readOnly = false, ref }: TijdlijnProps) {
    return (
        <SidebarContent className="gap-0" ref={ref}>
            <RoleGate roles={[UserRole.REGIEVOERDER]}>
                {!readOnly && (
                    <SidebarGroup className="py-0">
                        <Timeline>
                            <TimelineLine dashed className="top-6" />
                            <div className="grid gap-8">
                                <Herinneringen />
                            </div>
                        </Timeline>
                    </SidebarGroup>
                )}
            </RoleGate>
            <RoleGate roles={[UserRole.REGIEVOERDER, UserRole.KLANTENSERVICE, UserRole.TRANSVISION, UserRole.DEWIT]}>
                {!readOnly && (
                    <>
                        <SidebarGroup className="bg-emphasis-primary py-0">
                            <Timeline>
                                <TimelineLine dashed />
                                <div className="grid gap-8 py-4">
                                    <Acties dossierNummer={dossierNummer} />
                                    <RoleGate roles={[UserRole.REGIEVOERDER]}>
                                        <Suggesties dossierNummer={dossierNummer} />
                                    </RoleGate>
                                </div>
                            </Timeline>
                        </SidebarGroup>
                    </>
                )}
            </RoleGate>
            <SidebarSeparator />
            <SidebarGroup className="pt-0">
                <SidebarGroupLabel className="sr-only">Logboek</SidebarGroupLabel>
                <SidebarGroupContent>
                    <Logboek dossierNummer={dossierNummer} activeFilters={activeFilters} readonly={readOnly} />
                </SidebarGroupContent>
            </SidebarGroup>
        </SidebarContent>
    );
}
